import React, { useState } from "react";
import { Line } from "react-chartjs-2";
import "chart.js/auto";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../css/ReportsPage.css";

const ReportsPage = () => {
  // Device to MAC variable mapping
  const deviceMacMap = {
    "Room 1 - Device 1": "76C130502BB3",
    "Room 1 - Device 2": "488095E6D542",
    "Room 2 - Device 1": "76C130202C6C",
    "Room 3 - Device 1": "76C130102E9D",
    "HKAP0100000045": "76C130102C7F",
    "HKAP0100000071": "76C130102E97",
    "HKAP0100000050": "76C130102E9D",
    "HKAP0100000052": "76C130102E9E",
    "HKAP0100000054": "76C130202C6C",
    "HKAP0100000057": "76C130202C6C",
    "HKAP0100000038": "76C130202C74",
    "HKAP0100000059": "76C130202C7B",
    "HKAP0100000058": "76C130302BD4",
    "HKAP0100000056": "76C130302BE5",
    "HKAP0100000046": "76C130402B33",
    "HKAP0100000068": "76C130402B38",
    "HKAP0100000061": "76C130502BA8",
    "HKAP0100000078": "76C130502BB7",
    "HKAP0100000063": "76C130502E90",
    "HKAP0100000030": "76C13060241C",
    "HKAP0100000079": "76C130602421",
    "HKAP0100000037": "78C130402B3A",
    "HKAP0100000120": "76C130102E8F",
  };

  const [selectedDevice, setSelectedDevice] = useState("");
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().slice(0, 10));
  const [startTime, setStartTime] = useState("00:00");
  const [endTime, setEndTime] = useState("23:59");
  const [token, setToken] = useState("");
  const [rrData, setRrData] = useState([]);
  const [hrData, setHrData] = useState([]);
  const [filteredRrData, setFilteredRrData] = useState([]);
  const [filteredHrData, setFilteredHrData] = useState([]);
  const [showRemainingElements, setShowRemainingElements] = useState(false);
  const [name, setName] = useState('');
  const [birthday, setBirthday] = useState('');
  const [gender, setGender] = useState('');
  const [email, setEmail] = useState('');
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [relaxationScore, setRelaxationScore] = useState(null);

  const navigate = useNavigate();

  const devices = Object.keys(deviceMacMap)
  .filter((key) => key.startsWith("")) // 過濾出以 "Room" 開頭的鍵
  .sort();  

  const handleDeviceSelect = (device) => {
    setSelectedDevice(device);
  };

  const handleStartTimeChange = (e) => {
    setStartTime(e.target.value);
  };

  const handleEndTimeChange = (e) => {
    setEndTime(e.target.value);
  };

  const calculateRelaxationScore = (filteredHr, filteredRr) => {
    if (filteredHr.length === 0 || filteredRr.length === 0) {
      setRelaxationScore("N/A");
      return;
    }

    // 計算 HR_Lowering（心率降低的百分比）
    const hrBaseline = filteredHr[0]?.value || 0;
    const hrFinal = filteredHr[filteredHr.length - 1]?.value || 0;
    const HR_Lowering = hrBaseline > 0 ? ((hrBaseline - hrFinal) / hrBaseline) * 100 : 0;

    // 計算 BR_Stability（呼吸穩定度，呼吸率的最大值與最小值的差）
    const brValues = filteredRr.map((item) => item.value);
    const brMax = Math.max(...brValues);
    const brMin = Math.min(...brValues);
    const BR_Stability = brMax - brMin;

    // 計算 Time_Adjusted_Relaxation（根據放鬆時間進行調整）
    const sessionDuration = filteredHr.length; // 假設每筆數據代表 1 分鐘
    const Time_Adjusted_Relaxation = sessionDuration > 60 ? 1 : sessionDuration / 60; // 若時間超過 60 分鐘，設為最大值 1

    // 計算最終放鬆分數（加權計算）
    const W1 = 0.4, W2 = 0.4, W3 = 0.2;
    const Relaxation_Score = W1 * HR_Lowering + W2 * (100 - BR_Stability) + W3 * (Time_Adjusted_Relaxation * 100);

    setRelaxationScore(Math.round(Relaxation_Score)); // 四捨五入取整數
  };

  const filterData = (rrData, hrData) => {
    // 定義開始和結束時間
    const startDateTime = new Date(`${selectedDate}T${startTime}:00`);
    const endDateTime = new Date(`${selectedDate}T${endTime}:00`);
  
    // 過濾數據的輔助函數
    const filterArray = (dataArray) => {
      // 確保傳入的數據是數組，否則返回空數組
      if (!Array.isArray(dataArray)) {
        return [];
      }
  
      // 過濾數據，僅保留在時間範圍內的數據
      return dataArray.filter((entry) => {
        const entryTime = new Date(
          `${entry.time.slice(0, 4)}-${entry.time.slice(4, 6)}-${entry.time.slice(6, 8)}T${entry.time.slice(8, 10)}:${entry.time.slice(10, 12)}:${entry.time.slice(12, 14)}`
        );
        return entryTime >= startDateTime && entryTime <= endDateTime;
      });
    };
  
    // 應用過濾函數
    const filteredRr = filterArray(rrData);
    const filteredHr = filterArray(hrData);
  
    // 更新狀態
    setFilteredRrData(filteredRr);
    setFilteredHrData(filteredHr);
  
    // 計算放鬆分數
    calculateRelaxationScore(filteredHr, filteredRr);
  };

  var querystring = require('querystring');
  const handleSubmit = async (e) => {
    e.preventDefault(); // 阻止表單的默認提交行為
  
    // 驗證用戶是否選擇了必要的參數
    if (selectedDevice && selectedDate && startTime && endTime) {
      try {
        // 發送 POST 請求到 API
        const response = await axios.post(
          "https://aisx6r0ac1.execute-api.ap-southeast-1.amazonaws.com/dev/api",
          {
            mac: deviceMacMap[selectedDevice], // 根據選擇的設備獲取對應的 MAC 地址
            date: selectedDate.replace(/-/g, ""), // 將日期格式轉換為 YYYYMMDD
          },
          {
            headers: {
              "Content-Type": "application/json", // 設置請求頭，指定為 JSON 格式
            },
          }
        );
  
        console.log(response); // 調試用，打印 API 回應
  
        // 解析 API 回應的 body
        const responseBody = JSON.parse(response.data.body);
  
        // 從 API 回應中提取 `rrData` 和 `hrData`
        const { rrData = [[]], hrData = [[]] } = responseBody.data || {};
  
        // 驗證數據結構是否正確
        if (!Array.isArray(rrData) || !Array.isArray(hrData)) {
          throw new Error("Invalid data format: rrData or hrData is not an array.");
        }
  
        // 展平嵌套數組
        const flattenedRrData = rrData.flat(); // 將 `rrData` 由嵌套數組轉換為一維數組
        const flattenedHrData = hrData.flat(); // 將 `hrData` 由嵌套數組轉換為一維數組
  
        // 更新狀態
        setRrData(flattenedRrData);
        setHrData(flattenedHrData);
  
        // 根據時間範圍過濾數據
        filterData(flattenedRrData, flattenedHrData);
  
        // 顯示報告的其他界面元素
        setShowRemainingElements(true);
      } catch (error) {
        // 捕獲並處理錯誤（例如 API 請求失敗）
        console.error("Error fetching history data:", error);
        alert("Error fetching data. Please try again later.");
      }
    } else {
      // 如果用戶未選擇設備、日期或時間範圍，提示錯誤信息
      alert("Please select a device, date, start time, and end time.");
    }
  };

  const heartRateData = {
    labels: filteredHrData.map((item) =>
      new Date(
        `${item.time.slice(0, 4)}-${item.time.slice(4, 6)}-${item.time.slice(6, 8)}T${item.time.slice(8, 10)}:${item.time.slice(10, 12)}:${item.time.slice(12, 14)}`
      ).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
    ),
    datasets: [
      {
        label: "Heart Rate",
        data: filteredHrData.map((item) => item.value),
        backgroundColor: "rgba(75, 192, 192, 0.2)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
    ],
  };

  const breathRateData = {
    labels: filteredRrData.map((item) =>
      new Date(
        `${item.time.slice(0, 4)}-${item.time.slice(4, 6)}-${item.time.slice(6, 8)}T${item.time.slice(8, 10)}:${item.time.slice(10, 12)}:${item.time.slice(12, 14)}`
      ).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
    ),
    datasets: [
      {
        label: "Breath Rate",
        data: filteredRrData.map((item) => item.value),
        backgroundColor: "rgba(255, 99, 132, 0.2)",
        borderColor: "rgba(255, 99, 132, 1)",
        borderWidth: 1,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    scales: {
      y: {
        beginAtZero: true, // Ensure graph starts at 0
      },
    },
  };



  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (name && birthday && gender && email && agreedToTerms) {
      // Process the form data and send email to the customer
      console.log('Form submitted:', {
        name,
        birthday,
        gender,
        email,
        agreedToTerms,
      });
      setIsSubmitted(true);
    } else {
      alert('Please fill in all the required fields and agree to the terms and conditions.');
    }
  };

  const handleBackToDashboard = () => {
    navigate('/db');
  };




  return (
    <div className="reports-page-container">
      <h1 className="reports-page-title">Reports</h1>
      <div className="device-selection-container">
        <h2 className="device-selection-title">Select Device</h2>
        <div className="device-selection-buttons">
          {devices.map((device, index) => (
            <button
              key={index}
              onClick={() => handleDeviceSelect(device)}
              className={`device-button ${selectedDevice === device ? "active" : ""}`}
            >
              {device}
            </button>
          ))}
        </div>
      </div>
      {selectedDevice && (
        <div className="reports-container">
          <div className="date-time-selection">
            <div className="date-selection">
              <label className="date-label">Date:</label>
              <input
                className="date-input"
                type="date"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
              />
            </div>
            <div className="time-selection">
              <label className="time-label">Start Time:</label>
              <input
                className="time-input"
                type="time"
                value={startTime}
                onChange={handleStartTimeChange}
              />
              <label className="time-label">End Time:</label>
              <input
                className="time-input"
                type="time"
                value={endTime}
                onChange={handleEndTimeChange}
              />
            </div>
          </div>
          <button className="form-button" onClick={handleSubmit}>
            View Reports
          </button>

          {showRemainingElements && (
            <>
              <div className="chart-container">
                <div className="chart">
                  <h3 className="chart-title">Heart Rate</h3>
                  <Line data={heartRateData} options={chartOptions} />
                </div>
                <div className="chart">
                  <h3 className="chart-title">Breath Rate</h3>
                  <Line data={breathRateData} options={chartOptions} />
                </div>
              </div>
              <div className="relaxation-score-container">
                <h3 className="relaxation-score-title">Relaxation Score</h3>
                <div className="relaxation-score">{relaxationScore || "Calculating..."}</div>
              </div>
              {!isSubmitted && (
                <form className="customer-info-form" onSubmit={handleFormSubmit}>
                  <div className="form-group">
                    <label className="form-label">Name:</label>
                    <input
                      className="form-input"
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Birthday:</label>
                    <input
                      className="form-input"
                      type="date"
                      value={birthday}
                      onChange={(e) => setBirthday(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Gender:</label>
                    <select
                      className="form-select"
                      value={gender}
                      onChange={(e) => setGender(e.target.value)}
                    >
                      <option value="">Select Gender</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Email:</label>
                    <input
                      className="form-input"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-checkbox-label">
                      <input
                        className="form-checkbox"
                        type="checkbox"
                        checked={agreedToTerms}
                        onChange={(e) => setAgreedToTerms(e.target.checked)}
                      />
                      I agree to the <a href="https://www.katlai.com/app-policy" target="_blank" rel="noopener noreferrer">terms and conditions</a>.
                    </label>
                  </div>
                  <button className="form-button" type="submit">
                    Submit
                  </button>
                </form>
              )}
              {isSubmitted && (
                <div className="success-message">
                  <h2 className="success-title">Thank you.</h2>
                </div>
              )}
              <button className="back-button" onClick={handleBackToDashboard}>
                Back to Dashboard
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default ReportsPage;